<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <button @click="(event) => handleButtonPress(event)">New User</button>
      </div>
      <!-- <Insights :cardInfo="cardInfo" :callback="updateFiltersForSearchBasedOnCard" /> -->
    </div>
    <div class="currentView">
      <!-- These selectors should probably be their own component -->
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector" id="filtersModal">
            <SearchBar v-bind:search="search" v-bind:searchCallback="(data) => { this.performSearch(data) }"
              :searchIcon="true">
            </SearchBar>
          </div>
        </div>
        <DataTable v-bind:tableData="usersTableData" v-bind:configuration="users" v-bind:search="search"
          v-bind:openModalCallback="(item) => { handleModal(item); }" />

        <AnalyticsGraph title="At a Glance" v-bind:configuration="users" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../ContentHeader";
import * as Constants from "../../js/constants";
import EventBus from "../../eventBus";
import DataTable from "./pageComps/DataTable.vue";
import UsersModal from "../modals/UsersModal.vue";
import SearchBar from "./pageComps/Search.vue";
import CTSRepository from "../../js/CTSRepository";
// import Insights from "../layout/Insights.vue";

export default {
  name: "UsersPage",
  props: ["subPage", "organizationData", "userData"],
  components: {
    ContentHeader,
    DataTable,
    SearchBar,
    // Insights
  },
  data() {
    return {
      showKeys: false,
      showIncidents: false,
      selectedItem: Constants.GATE,
      headerName: Constants.USERS,
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      filters: [],
      usersTableData: [],
      tableData: [],
      search: "",
      users: Constants.USERS,
      cardInfo: Constants.DEFAULT_CARD_INFO
    };
  },
  created() {
    this.changeView(this.selectedItem);
    EventBus.$on("keys", this.changeView);
    EventBus.$on("incidents", this.changeView);

    var date = new Date();
    this.defaultEndDate = date.toISOString().split('T')[0]
    var startDate = new Date(date)
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06"
  },
  watch: {
    organizationData: function (newVal) {
      if (newVal != null) {

        this.performSearch("").then((apiData) => {
          console.log("Finished getting and setting API Data", apiData);
        });
      }
    }
  },

  mounted() {
    this.performSearch(this.search).then((apiData) => {
      console.log("Finished getting and setting API Data", apiData);
    });
  },
  methods: {
    openGateFiletersModal() {
      console.log("Opening Gate Filters Modal")
    },
    homeChangeText() {
      console.log("Home knows the button was clicked");
    },
    changeView(name) {
      console.log("Changing View from ", this.selectedItem, " to ", name);
      if (name == "keys") {
        this.showKeys = true;
        this.showIncidents = false;
        this.selectedItem = name;
      } else if (name == "incidents") {
        this.showIncidents = true;
        this.showKeys = false;
        this.selectedItem = name;
      }
    },
    getUsersData() {
      return new CTSRepository(this.$props.organizationData).fetchResidents("")
        .then((data) => {
          console.log("Response Data", data, this);
          this.usersTableData = data.data;
          console.log("Set Data", this);

        })
        .catch((err) => {
          console.log("Error getting users Data", err)
        });
    },
    performSearch(data) {
      this.search = data
      return new CTSRepository(this.$props.organizationData).fetchResidents(data)
        .then((data) => {
          console.log("Search Data", data);
          this.usersTableData = data.data
        })
        .catch((err) => {
          console.log("Error fetching Residents from Users", err)
        });
    },
    getDataFromAPI() {
      this.getUsersData()
    },
    handleModal(item) {
      this.$modal.show(UsersModal, {
        selectedUserData: item,
        organizationData: this.$props.organizationData,
        userData: this.$props.userData,
      }, {
        transition: "fade",
        top: "0",
        width: "650",
        height: "auto",
        draggable: "true",
        adaptive: false,
        styles: "border-radius: 22px;"
      })
    },
    handleButtonPress() {
      this.$modal.show(Constants.CREATE_USERS_MODAL)
    }
  },
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  widows: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
  display: inline;
  margin-right: 16px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.pageHeader button {
  background-color: #1890FFCC;
  color: white;
}

.filterIcon {
  margin-right: 16px;
  display: inline;

}

.iconGroup {
  display: inline;
}
</style>